export default __webpack_public_path__ + "static/media/5.8cd5406d.png";